import { z } from "zod"

// See https://ip-api.com/docs/api:json
export const IpApiResponseSchema = z
    .object({
        query: z.string(),
        countryCode: z.string().optional(),
        lat: z.number().optional(),
        lon: z.number().optional(),
    })
    .transform((r) => ({ ...r, ip: r.query }))
